import { render } from "./Documentation.vue?vue&type=template&id=2c352b68&scoped=true"
const script = {}

import "./Documentation.vue?vue&type=style&index=0&id=2c352b68&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c352b68"]])

export default __exports__